var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Example"}},[_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":"chartCanvas","width":"360"}})])
}]

export { render, staticRenderFns }